module.exports = __webpack_public_path__ + "static/img/activity_one.83935eb8.jpg";